module.exports = __webpack_public_path__ + "img/collection-engagementRings025Carat.bced2d7.webp";